import React, { useState, useEffect } from 'react';
import { getDocs, collection, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';
import '../Styles/Updates.css';

export default function Updates() {
  const [updates, setUpdates] = useState([]);
  const [activeUpdate, setActiveUpdate] = useState(null);

  useEffect(() => {
    const fetchUpdates = async () => {
      try {
        const updatesQuery = query(collection(db, 'updates'), orderBy('date', 'desc'));
        const updatesSnapshot = await getDocs(updatesQuery);
        const updatesList = updatesSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setUpdates(updatesList);
      } catch (error) {
        console.error('Error fetching updates:', error);
      }
    };

    fetchUpdates();
  }, []);

  return (
    <section className="updates-section">
      <ul className="updates-list">
        {updates.map(update => (
          <li key={update.id} onClick={() => setActiveUpdate(update)} className="update-item">
            <h3>{update.title}</h3>
            <p>{update.summary}</p>
          </li>
        ))}
      </ul>

      {activeUpdate && (
        <div className="update-popup">
          <div className="popup-content">
            <button className="close-btn" onClick={() => setActiveUpdate(null)}>Close</button>
            <h3>{activeUpdate.title}</h3>
            <div className="update-text">
              {activeUpdate.text.split('\n').map((line, index) => (
                <p key={index}>{line}</p>
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
